import React from "react";
import "./smallLoader.scss";

const SmallLoader = () => (<div id="small-loader">
    <svg xmlns="http://www.w3.org/2000/svg" className="circular-loader" viewBox="0 0 50 50" overflow="visible">
        <circle className="primary-stroke" cx="25" cy="25" r="20" fill="none" stroke="#70c542" strokeWidth="3"/>
    </svg>
</div>);

export default SmallLoader;